import { Component, OnInit } from '@angular/core';
import { ServiceProductCollection, ServiceSubscriptionCollection, SubscriptionService } from 'taxtank-core';
import { take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import {
  SubscriptionBannerPastDueComponent
} from '@components/subscription-banner/subscription-banner-past-due/subscription-banner-past-due.component';
import {
  SubscriptionBannerTrialComponent
} from '@components/subscription-banner/subscription-banner-trial/subscription-banner-trial.component';
import { BaseComponent } from '@shared/component/base/base.component';

/**
 * subscription reminders like expired trial or failed payment
 */
@Component({
  selector: 'app-subscription-reminder',
  templateUrl: './subscription-reminder.component.html',
  styleUrls: ['./subscription-reminder.component.scss'],
  standalone: false
})
export class SubscriptionReminderComponent extends BaseComponent implements OnInit {
  constructor(private subscriptionService: SubscriptionService, private dialog: MatDialog) {
    super();
  }

  ngOnInit(): void {
    const user = this.userService.getCacheFirst();
    this.subscriptionService.get().pipe(take(1)).subscribe((subscriptions: ServiceSubscriptionCollection) => {
      // past due reminder
      const paidSubscription = subscriptions.getActivePaid();
      if (paidSubscription && paidSubscription.isPastDue()) {
        // @TODO clean up after tests
        // this.openPastDueDialog();
      }

      // expired trials reminder shown once, skip if there is no active subscription (expired subscription banner shown instead)
      const expiredTrials = subscriptions.getTrials().getExpiredAfter(user.lastSeen);
      if (!expiredTrials.length || !subscriptions.getActive().length) {
        return;
      }

      const expiredProducts = expiredTrials.getItems().prices.products;
      // remove paid products from expired products
      if (paidSubscription) {
        expiredProducts.remove(paidSubscription.getItems().prices.products.toArray());
      }

      if (expiredProducts.length) {
        this.openExpiredTrialsDialog(expiredProducts);
      }
    });
  }

  /**
   * Subscription payment failed, but still active while we are waiting for user to fix it
   */
  private openPastDueDialog(): void {
    this.dialog.open(SubscriptionBannerPastDueComponent, {
      panelClass: 'dialog-banner'
    });
  }

  private openExpiredTrialsDialog(products: ServiceProductCollection): void {
    this.dialog.open(SubscriptionBannerTrialComponent, {
      panelClass: 'dialog-banner',
      data: products
    });
  }
}
